import api from './client';

function authConfig(token) {
  return token ? { headers: { Authorization: `Bearer ${token}` } } : {};
}

export async function fetchDashboard(token, params = {}) {
  const { data } = await api.get('/api/reports/dashboard', {
    params,
    ...authConfig(token)
  });
  return data;
}

export async function fetchSalesReport(token, params = {}) {
  const { data } = await api.get('/api/reports/sales', {
    params,
    ...authConfig(token)
  });
  return data;
}

export async function fetchInventoryReport(token, params = {}) {
  const { data } = await api.get('/api/reports/inventory', {
    params,
    ...authConfig(token)
  });
  return data;
}

export async function fetchDocumentsReport(token, params = {}) {
  const { data } = await api.get('/api/reports/documents', {
    params,
    ...authConfig(token)
  });
  return data;
}
